import { useEffect, useState } from "react";
import { hubApi } from "./hub";

export interface ServiceStatus {
  killed: boolean;
  reason: "budget" | "manual" | null;
  resumesAt: string | null;
}

/** User-facing copy for the cost kill switch. Empty when everything is running. */
export function pausedMessage(s: ServiceStatus | null): string {
  if (!s?.killed) return "";
  if (s.reason === "budget" && s.resumesAt) {
    const date = new Date(s.resumesAt).toLocaleDateString("en-GB", { day: "numeric", month: "short", timeZone: "UTC" });
    return `Calls are paused until ${date}: 1sky has reached this month's running-cost limit. Chat in existing rooms still works.`;
  }
  return "Calls are paused for maintenance. Please try again a little later.";
}

/** Polls the hub's public status (cheap, uncached) so pages can show the paused notice. */
export function useServiceStatus(pollMs = 60_000): ServiceStatus | null {
  const [status, setStatus] = useState<ServiceStatus | null>(null);
  useEffect(() => {
    let alive = true;
    const load = () =>
      hubApi
        .call<ServiceStatus>("/api/status")
        .then((s) => alive && setStatus(typeof s?.killed === "boolean" ? s : null))
        .catch(() => undefined);
    void load();
    const t = setInterval(load, pollMs);
    return () => {
      alive = false;
      clearInterval(t);
    };
  }, [pollMs]);
  return status;
}
